import { render, staticRenderFns } from "./InputSigarusSwitch.vue?vue&type=template&id=7542cb26&"
import script from "./InputSigarusSwitch.vue?vue&type=script&lang=js&"
export * from "./InputSigarusSwitch.vue?vue&type=script&lang=js&"
import style0 from "./InputSigarusSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports